import { FormSection } from '@strata/react-form-section';
import { InlineMessage } from '@strata/react-inline-message';
import { useState } from 'react';

import { NoticeDetailsDialog } from 'components/wonReferrals/dialogs/NoticeDetailsDialog';
import { ReferralDetails } from 'store/api/treatmentApi';

interface NoticeBoardProps {
    referralDetails?: ReferralDetails;
}

export const NoticeBoard = ({ referralDetails = undefined }: NoticeBoardProps) => {
    const [noticeDetails, setNoticeDetails] = useState<ReferralDetails['copayAssistanceMessage']>();

    return (
        <>
            <NoticeDetailsDialog
                noticeDetails={noticeDetails}
                onSecondaryButtonClick={() => setNoticeDetails(undefined)}
            />
            <FormSection
                sectionTitle="Notice Board"
                isLoading={!referralDetails}
                content={
                    <InlineMessage
                        title={referralDetails?.copayAssistanceMessage?.title}
                        label={
                            <>
                                {referralDetails?.copayAssistanceMessage?.shortMessage}
                                {referralDetails?.copayAssistanceMessage?.longMessage ? (
                                    <div className="padding__top--small">
                                        <u
                                            role="button"
                                            style={{ cursor: 'pointer' }}
                                            tabIndex={0}
                                            onClick={() =>
                                                setNoticeDetails(
                                                    referralDetails?.copayAssistanceMessage,
                                                )
                                            }
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    setNoticeDetails(
                                                        referralDetails?.copayAssistanceMessage,
                                                    );
                                                }
                                            }}
                                        >
                                            See Details
                                        </u>
                                    </div>
                                ) : null}
                            </>
                        }
                        intent={InlineMessage.Intent.INFO}
                        wrapText
                    />
                }
            />
        </>
    );
};
